import _ from 'lodash';
import axios from 'axios'; // eslint-disable-line import/no-extraneous-dependencies
import * as types from '../constants/ActionTypes';

const TOPIC_TREE_URL = '/smarthelp/topic-tree';
const TOPIC_MESSAGE = 'topictree request canceled';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();


function requestTopicTreeData() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTreeData(reponseData) {
  const topicTree = _.get(reponseData, 'topicTree.contact_email_template', {});
  return {
    type: types.RECEIVE_TOPIC_TREE_RESPONSE,
    payload: topicTree,
  };
}


function receiveTopicTreeDataError() {
  return {
    type: types.RECEIVE_TOPIC_TREE_ERROR,
    payload: undefined,
  };
}

function fetchTopicTree() {
  return (dispatch) => {
    dispatch(requestTopicTreeData());
    return axios.get(TOPIC_TREE_URL, {
      cancelToken: source.token,
    })
      .then(response => dispatch(receiveTopicTreeData(response.data)))
      .catch((error) => {
        if (error && error.message !== TOPIC_MESSAGE) {
          dispatch(receiveTopicTreeDataError());
        }
      });
  };
}
function cancelTopicTreeRequest() {
  source.cancel(TOPIC_MESSAGE);
}


module.exports = {
  fetchTopicTree,
  cancelTopicTreeRequest,
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-message-topic-tree.js